import React, { Fragment, useEffect, useState } from 'react';
import { AiOutlineSchedule, AiOutlineWarning } from 'react-icons/ai';
import { MdCheckCircle, MdPlaylistAddCheck } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import _Confirmacao from '../../../../assets/images/Data_Confirmacao.svg';
import flagBrasil from '../../../../assets/images/icons/flagBrasil.png';
import { useGetSettings } from '../../../../domain';
import api from '../../../../services/api';
import { getDiffDaysFromToday } from '../../../../utils/dateUtilities';
import AppToolBar from '../../components/AppToolBar';
import BarTop from '../../components/BarTop';
import { QueueHeader } from '../components/QueueHeader';
import { DriverOrder } from '../DriverOrder';
import './styles.css';

interface Truck {
  id: number;
  vehicleModel: { name: string };
  licensePlate: string;
  selected?: boolean;
  color: string;
}

export interface Customer {
  code: number;
  name: string;
  city: string;
}

export interface ShippingCompany {
  name: string;
}

export interface Order {
  id: number;
  status: string;
  code: string;
  customer: Customer;
  shippingCompany: ShippingCompany[];
  orderItem: OrderItem[];
}

interface Product {
  code: number;
  name: string;
}

interface OrderItem {
  id: number;
  quantity: number;
  product: Product;
}

interface Scheduling {
  id?: number;
  qtyOrdered?: number;
  order?: Order;
  selected?: boolean;
  expirationDate?: string;
}

interface SchedulingWithTruck extends Scheduling {
  truck: Truck;
}

interface CreateQueueData {
  company: { id: number };
  truck: { id: number };
  scheduling: { id: number } | null;
}

export function DriverScheduling() {
  const history = useHistory();

  const [trucks, setTrucks] = useState<Truck[]>([
    {
      id: 0,
      vehicleModel: { name: '' },
      licensePlate: '',
      color: '',
      selected: false,
    },
  ]);
  const [scheduling, setScheduling] = useState<Scheduling[]>([]);

  const [disable, setDisable] = useState(1);

  const [error, setError] = useState({
    status: 1,
    message1: '',
    message2: '',
    message3: '',
  });

  const [anonPage, setAnonPage] = useState(0);
  const [truckId, setTruckId] = useState(0);
  const [ifAnon, setIfAnon] = useState(false);

  const [selectedLicesePlate, setSelectedLicensePlate] = useState('');
  const [selectedScheduling, setSelectedScheduling] = useState<Scheduling>();
  const [selectedVehicleModel, setSelectedVehicleModel] = useState('');
  const [selectedVehicleColor, setSelectedVehicleColor] = useState('');

  const [isSelectingVehicle, setIsSelectingVehicle] = useState(false);
  const companyId = sessionStorage.getItem('@AppDriver:companyId');
  const driverId = sessionStorage.getItem('@AppDriver:id');

  let loading = false;
  // let selectedTruckId = 0;

  async function fetchSchedulingDriverData() {
    if (!driverId) return;

    api.get(`/scheduling/driver/${driverId}`).then((response) => {
      let schedulingTrucks = response.data.map((item: any) => {
        return item.truck;
      });

      let resArr: any = [];

      if (schedulingTrucks.length > 0) {
        schedulingTrucks.filter((item: Truck, index: number) => {
          if (index === 0) {
            setSelectedLicensePlate(item?.licensePlate);
            setSelectedVehicleModel(item.vehicleModel?.name);
            setSelectedVehicleColor(item?.color);
          }

          var i = resArr.findIndex((x: Truck) => x.licensePlate === item.licensePlate);

          if (i <= -1) {
            resArr.push({
              vehicleModel: item.vehicleModel,
              licensePlate: item.licensePlate,
              color: item.color,
              selected: index === 0 ? true : false,
            });
          }

          return null;
        });

        setTrucks(resArr);
      }

      if (schedulingTrucks.length === 0) {
        setIfAnon(true);
        setAnonPage(1);

        api.get(`/truck/driver/${driverId}`).then((response) => {
          let truck_array = response.data.map((item: any) => {
            return item;
          });
          resArr = truck_array;
          setTrucks(resArr);
        });
      }
    });
  }

  function handleSelected(truck: Truck) {
    setSelectedLicensePlate('');
    setSelectedVehicleModel('');

    const _trucks = trucks.map((item) => {
      if (item.licensePlate === truck.licensePlate) {
        setTruckId(item.id);
        if (!item.selected) {
          setSelectedVehicleModel(truck.vehicleModel?.name || '');
          setSelectedVehicleColor(truck.color);
          setSelectedLicensePlate(truck.licensePlate);
        }

        return {
          id: item.id,
          vehicleModel: item.vehicleModel,
          licensePlate: item.licensePlate,
          color: item.color,
          selected: !item.selected,
        };
      } else
        return {
          id: item.id,
          vehicleModel: item.vehicleModel,
          licensePlate: item.licensePlate,
          color: item.color,
          selected: false,
        };
    });

    setTrucks(_trucks);
  }

  function handleSelectedSchedule(scheduling_: Scheduling) {
    setSelectedScheduling({});
    const _scheduling = scheduling.map((item) => {
      if (item.id === scheduling_.id) {
        if (!item.selected) {
          setSelectedScheduling(scheduling_);
        }
        return { ...item, selected: !item.selected };
      } else return { ...item, selected: false };
    });

    setScheduling(_scheduling);
  }

  async function handleNext() {
    const id = sessionStorage.getItem('@AppDriver:id');

    const { data } = await api.get<Scheduling[]>(`/scheduling/driver/${id}/licenseplate/${selectedLicesePlate}`);

    const schedulingId = data[0]?.id;
    const truckIdResponse = await api.get<SchedulingWithTruck>(`/scheduling/${schedulingId}`);
    const truckId = truckIdResponse.data.truck.id;

    setTruckId(truckId);

    const _scheduling = data
      .sort((a, b) => {
        const dateA = new Date(a.expirationDate || '').getTime();
        const dateB = new Date(b.expirationDate || '').getTime();
        return dateA - dateB;
      })
      .map((item, index) => ({ ...item, selected: index === 0 }));

    setScheduling(_scheduling);
    setSelectedScheduling(_scheduling[0]);
  }

  function handleConfirmAnon() {
    if (truckTotal > 0) {
      setAnonPage(2);
    } else if (truckTotal === 0) {
      if (!loading) {
        loading = true;
        handleConfirm();
      }
    }
  }

  function createQueue(data: CreateQueueData) {
    const id = parseInt(sessionStorage.getItem('@AppDriver:id') || '');

    const queueData = { driver: { id }, ...data };

    if (!truckId) return toast.error('Selecione um veículo!');

    api
      .post('queue/save', queueData)
      .then(() => {
        setDisable(0);
        setTimeout(() => history.push('/app/agendamento/status', { from: history.location.pathname }), 5000);
      })
      .catch((e) => {
        let message = e.response.data.message;

        if (message?.search('Você') !== -1) {
          setError({
            status: 0,
            message1: message?.slice(0, message?.length - 80),
            message2: message?.slice(50, 80),
            message3: message?.slice(80, message?.length),
          });
        } else {
          setError({
            status: 0,
            message1: message,
            message2: message.slice(0, 0),
            message3: message.slice(0, 0),
          });
        }

        setTimeout(() => {
          history.push('/');
        }, 5000);
      });
  }

  function handleConfirm() {
    const data = {
      company: {
        id: parseInt(companyId || ''),
      },
      truck: {
        id: truckId,
      },
      scheduling: selectedScheduling?.id ? { id: selectedScheduling.id } : null,
    };

    setIsSelectingVehicle(true);
    createQueue(data);
  }

  function handleConfirmValidation() {
    /* if (remainingDays <= 0) {
      return toast.error('O Pedido está expirado!');
    } */

    if (!loading) {
      loading = true;
      handleConfirm();
    }
  }

  const handleDenyOrder = (item: Scheduling, index: number) => {
    const id = item.id;

    if (id) {
      api
        .delete(`/scheduling/delete/${id}`)
        .then((response) => {
          if (response.status === 200) {
            toast.success('Recusado com sucesso!');
            const results = scheduling.filter((item) => item.id !== id);
            setScheduling(results);

            api.post('scheduling/save', results);
          }
        })
        .catch(() => {
          toast.success('Erro ao recusar!');
        });
    } else {
      scheduling.splice(index, 1);
      setScheduling(scheduling);
    }
  };

  const handleAcceptOrder = (item: Scheduling) => {
    const data = {
      company: {
        id: parseInt(companyId || ''),
      },
      truck: {
        id: truckId,
      },
      scheduling: item?.id ? { id: item.id } : null,
    };

    createQueue(data);
  };

  const schedulingTotal = scheduling.length;
  const truckTotal = trucks.length;

  useEffect(() => {
    fetchSchedulingDriverData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="queue">
      <div className={error.status ? 'disable' : 'error-schedule'}>
        <AiOutlineSchedule size={80} />
        <div>Erro!</div>
        <div className="queue-failure">
          <div>
            <strong>{error.message1}</strong>
          </div>
          <div>
            <strong>{error.message2}</strong>
          </div>
          <div>
            <strong>{error.message3}</strong>
          </div>
        </div>
      </div>

      <div className={disable ? 'disable' : 'sucess-schedule'}>
        <img src={_Confirmacao} width={'40%'} alt="" />
        <div>Marcação</div>
        <strong>Confirmada</strong>
      </div>

      <div className="container">
        <BarTop />

        <div className="header">
          <AppToolBar pathToBack="/" isStatic={false} />
        </div>

        <div className="content">
          {selectedLicesePlate && (
            <div className="vehicle-info">
              <div className="vehicle-info-model">
                <div className="icon-vehicle-model" style={{ backgroundColor: selectedVehicleColor, border: '1px solid #00000060' }} />
                <div className="vehicle-model">{selectedVehicleModel}</div>
              </div>

              <span>{selectedLicesePlate}</span>
            </div>
          )}

          {!ifAnon && schedulingTotal === 0 && (
            <>
              <span> Selecione um veículo</span>
              <div className="licensePlates">
                {trucks.map((item, index) => (
                  <div key={index} className="license-container" id={item.licensePlate} onClick={() => handleSelected(item)}>
                    <span className={item.selected ? 'checked' : ''} style={{ display: 'none' }}>
                      <MdCheckCircle />
                    </span>
                    <div className="licensePlate">
                      <div className="info">
                        <div>BRASIL</div>
                        <span>
                          <img width={24} src={flagBrasil} alt="" />
                        </span>
                      </div>
                      <div className="license">{item.licensePlate}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="buttons base">{selectedLicesePlate !== '' ? <button onClick={handleNext}>Próximo</button> : <> </>}</div>
            </>
          )}

          {schedulingTotal === 0 && anonPage === 1 && truckTotal !== 0 && <SchedulingQueue onConfirmAnon={handleConfirmAnon} />}

          <TruckMessageWarning schedulingTotal={schedulingTotal} anonPage={anonPage} truckTotal={truckTotal} />

          {schedulingTotal === 0 && anonPage === 2 && truckTotal > 0 && (
            <>
              <span>Selecione um veículo</span>

              <div className="licensePlates">
                {trucks.map((item, index) => (
                  <div key={index} className="license-container" id={item.licensePlate} onClick={() => handleSelected(item)}>
                    <span className={item.selected ? 'checked' : ''} style={{ display: 'none' }}>
                      <MdCheckCircle />
                    </span>

                    <div className="licensePlate">
                      <div className="info">
                        <div>BRASIL</div>
                        <span>
                          <img width={24} src={flagBrasil} alt="" />
                        </span>
                      </div>
                      <div className="license">{item.licensePlate}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="buttons base">
                {selectedLicesePlate !== '' && (
                  <button disabled={isSelectingVehicle} className="button-select-vehicle" onClick={handleConfirmValidation}>
                    Continuar
                  </button>
                )}
              </div>
            </>
          )}

          {schedulingTotal > 0 && (
            <div className="schedulings queue">
              <div className="schedulings__wrapper--content">
                <QueueHeader Icon={MdPlaylistAddCheck}>Pedidos Autorizados</QueueHeader>

                {scheduling.map((item, index) => {
                  const orderName = item.order?.orderItem.reduce((item) => item).product.name;
                  const shipingCompany = item.order?.shippingCompany;
                  const remainingDays = getDiffDaysFromToday(item.expirationDate).value;
                  const isExpired = remainingDays <= 0;

                  if (isExpired) return null;

                  return (
                    <Fragment key={index}>
                      <DriverOrder
                        product={orderName}
                        qtyOrdered={item.qtyOrdered}
                        expirationDate={item.expirationDate}
                        shippingCompany={shipingCompany}
                        order={item.order}
                        customer={item.order?.customer}
                        truckPlate={selectedLicesePlate}
                        onClick={() => handleSelectedSchedule(item)}
                        denyOrder={() => handleDenyOrder(item, index)}
                        acceptOrder={() => handleAcceptOrder(item)}
                        selected={item.selected}
                      />

                      <hr />
                    </Fragment>
                  );
                })}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <button type="button" onClick={() => history.push('/app/history')} className="driver__order--btn expired-authorizations">
                  Ver todas as <strong>Autorizações Expiradas</strong>
                </button>

                {selectedScheduling?.id && (
                  <button type="button" disabled={loading} onClick={handleConfirmValidation} className="driver__order--btn enter-as-freelancer orange">
                    Entrar na fila como <strong>Autônomo</strong>
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

interface SchedulingQueueProps {
  onConfirmAnon: (event: any) => void;
}
function SchedulingQueue({ onConfirmAnon }: SchedulingQueueProps) {
  const companyId = sessionStorage.getItem('@AppDriver:companyId');
  const { settings } = useGetSettings(companyId || '');
  const disabled = !settings?.enableQueueWithoutScheduling;
  const history = useHistory();

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (disabled) return;

    onConfirmAnon(e);
  };

  const messageMatch = disabled ? 'Entre em contato com seu contratante e solicite a vinculação.' : 'Deseja registrar-se na fila como Autônomo?';

  return (
    <div className="schedule-frelancer">
      <div className="order-message-empty">
        <span>Você não possui pedidos!</span>
        <span>{messageMatch}</span>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
        <button onClick={() => history.push('/app/history')} className="driver__order--btn expired-authorizations" style={{ width: '75%' }}>
          Ver todas as <strong>Autorizações Expiradas</strong>
        </button>

        <button type="button" style={{ marginTop: 0, height: 'initial', paddingBlock: '10px' }} onClick={handleOnClick} disabled={disabled}>
          Entrar na Fila
        </button>
      </div>
    </div>
  );
}

interface TruckMessageWarningProps {
  schedulingTotal: number;
  anonPage: number;
  truckTotal: number;
}
function TruckMessageWarning({ anonPage, schedulingTotal, truckTotal }: TruckMessageWarningProps) {
  if (schedulingTotal === 0 && anonPage === 1 && truckTotal === 0) {
    return (
      <div className="advice schedule-page">
        <div>
          <div className="warn-icon">
            <AiOutlineWarning />
          </div>
          <div className="bold-text">ATENÇÃO!</div>
        </div>

        <p>Não há nenhum caminhão no seu cadastro. Edite seu perfil e cadastre um.</p>
      </div>
    );
  }

  return null;
}
